<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.2632 18.9474V6.31579L19.9474 0L13.6316 6.31579V10.5263H1V40H38.8947V18.9474H26.2632ZM9.42105 35.7895H5.21053V31.5789H9.42105V35.7895ZM9.42105 27.3684H5.21053V23.1579H9.42105V27.3684ZM9.42105 18.9474H5.21053V14.7368H9.42105V18.9474ZM22.0526 35.7895H17.8421V31.5789H22.0526V35.7895ZM22.0526 27.3684H17.8421V23.1579H22.0526V27.3684ZM22.0526 18.9474H17.8421V14.7368H22.0526V18.9474ZM22.0526 10.5263H17.8421V6.31579H22.0526V10.5263ZM34.6842 35.7895H30.4737V31.5789H34.6842V35.7895ZM34.6842 27.3684H30.4737V23.1579H34.6842V27.3684Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationCity"
};
</script>
